import { render, staticRenderFns } from "./MonthAllowancesPlanNameTable.vue?vue&type=template&id=19af5c0a&"
import script from "./MonthAllowancesPlanNameTable.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanNameTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports